/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaptureToken } from '../../models/capture-token';
import { CreateCaptureTokenDto } from '../../models/create-capture-token-dto';

export interface CreateOneBaseCaptureTokenControllerCaptureToken$Params {
      body: CreateCaptureTokenDto
}

export function createOneBaseCaptureTokenControllerCaptureToken(http: HttpClient, rootUrl: string, params: CreateOneBaseCaptureTokenControllerCaptureToken$Params, context?: HttpContext): Observable<StrictHttpResponse<CaptureToken>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseCaptureTokenControllerCaptureToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaptureToken>;
    })
  );
}

createOneBaseCaptureTokenControllerCaptureToken.PATH = '/api/capture-tokens';
